import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AdminLayout } from './components/admin/AdminLayout'
import { LoginPage } from './pages/LoginPage'
import { ChatTemplatesPage } from './pages/ChatTemplatesPage'
import { AnalyzeTemplatesPage } from './pages/AnalyzeTemplatesPage'
import { AnalyzeTasksPage } from './pages/AnalyzeTasksPage'
import { SystemConfigsPage } from './pages/SystemConfigsPage'
import { CategoryTreePage } from './pages/CategoryTreePage'

interface AuthUser {
  user_id: string
  username: string
  email: string
  phone: string
  nickname: string
  role: string
}

function getUser(): AuthUser | null {
  try {
    const u = localStorage.getItem('auth_user')
    return u ? JSON.parse(u) : null
  } catch {
    return null
  }
}

export default function App() {
  const [user, setUser] = useState<AuthUser | null>(null)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      setUser(getUser())
    }
    setChecking(false)
  }, [])

  const handleLogin = () => {
    setUser(getUser())
  }

  const handleLogout = () => {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_user')
    setUser(null)
  }

  if (checking) return null

  if (!user) {
    return <LoginPage onLogin={handleLogin} />
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AdminLayout user={user} onLogout={handleLogout} />}>
          <Route index element={<Navigate to="/chat-templates" replace />} />
          <Route path="chat-templates" element={<ChatTemplatesPage />} />
          <Route path="analyze-templates" element={<AnalyzeTemplatesPage />} />
          <Route path="analyze-tasks" element={<AnalyzeTasksPage />} />
          <Route path="system-configs" element={<SystemConfigsPage />} />
          <Route path="category-tree" element={<CategoryTreePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
